var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 57.2051L48 61.3743C96 65.6404 192 73.9788 288 77.7602C384 81.4445 480 80.4749 576 76.4027C672 72.4275 768 65.2526 864 64.283C960 63.3134 1056 68.5492 1152 72.9123C1248 77.2754 1344 80.7658 1392 82.608L1440 84.3533V-1.52588e-05H1392C1344 -1.52588e-05 1248 -1.52588e-05 1152 -1.52588e-05C1056 -1.52588e-05 960 -1.52588e-05 864 -1.52588e-05C768 -1.52588e-05 672 -1.52588e-05 576 -1.52588e-05C480 -1.52588e-05 384 -1.52588e-05 288 -1.52588e-05C192 -1.52588e-05 96 -1.52588e-05 48 -1.52588e-05H0V57.2051Z","fill":"current"}));
}

Wave.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 1440 85","fill":"none","preserveAspectRatio":"none"};

module.exports = Wave;

Wave.default = Wave;
